import { defineComponent as _defineComponent } from 'vue'
import { STATUS } from '@/constants'
import { CtSourceOrder, CtSupplierCatalogue } from '@/models/interfaces/content-type'
import { onMounted, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'


export default /*@__PURE__*/_defineComponent({
  __name: 'SupplierCatalogueRecentOrders',
  props: {
    catalogue: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props

const $store = useStore()
const $router = useRouter()
const $directr = $store.getters['Services/Directr']

const loading = ref(false)
const items = ref<Array<CtSourceOrder>>()

watch(() => props.catalogue, () => {
  items.value = undefined
  void fetch()
})

async function fetch () {
  if (!props.catalogue) return
  try {
    loading.value = true
    items.value = await $directr.get('source-order', [
      { select: ['reference', 'status', 'delivery'] },
      { field: 'catalogue', method: 'is', match: props.catalogue }], { limit: 3, order: '__created_at', distinct: '__created_at', direction: 'desc' })
      .then(({items}) => items)
  } catch (e) {
    console.error(e)
  } finally {
    loading.value = false
  }
}

function formatStatus (status: string) {
  return STATUS.get(status as any)?.sourceLabel || STATUS.get(status as any).label || ''
}

function toOrders (order?: string) {
  void $router.push({ name: 'SupplyOrders', params: { id: props.catalogue, order } })
}

onMounted(() => {
  void fetch()
})

const __returned__ = { props, $store, $router, $directr, loading, items, fetch, formatStatus, toOrders, get STATUS() { return STATUS }, get CtSourceOrder() { return CtSourceOrder }, get CtSupplierCatalogue() { return CtSupplierCatalogue }, onMounted, ref, watch, get useRouter() { return useRouter }, get useStore() { return useStore } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})